import Components from "../components";

class FaultIgnore extends Components.Base {
  onAllComponentsReady() {
    // Initialize child components (like Timestamp) and update status message
    // after all components (including FaultStatusMessage) are ready
    Components.collection.loadFragment(this.$el);
    this.updateHelpText();
  }

  bind() {
    this.on("ajax:rendered", () => {
      Components.collection.loadFragment(this.$el);
      this.updateHelpText();
    });
  }

  updateHelpText() {
    const text = this.$el.find(".dropdown-header").text().trim();
    $("body").trigger("fault-status-message:update", {
      message: text,
      source: "FaultIgnore",
      priority: 100,
    });
  }
}

Components.collection.register({
  selector: ".c-fault-ignore",
  klass: FaultIgnore,
});
